import { Close } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { TonConnectButton } from '@tonconnect/ui-react';
import { useContext, useEffect } from 'react';
import { DEVELOPMENT_MODE, STATIC_IMG_LOCATION } from '../../constants';
import FlexContainer from '../common/flex-container';
import IconButton from '../common/icon-button';
import styles from './index.module.css';
import LocationSwitcher from '../location-switcher';
import type RootContextProps from '../../types/root-context-props.ts';
import { RootContext } from '../../main.tsx';
import Locale from '../enums/locale.ts';

type MainHeaderProps = {
  isVisibleMainMenu: boolean;
  isMobileResolution: boolean | undefined;
  onMainMenuVisibleChange: () => void;
};

const MainHeader: React.FunctionComponent<MainHeaderProps> = (props: MainHeaderProps) => {
  const { locale, onLocaleChange }: RootContextProps = useContext(RootContext);

  useEffect(() => {
    if (import.meta.env.VITE_NODE_ENV_MODE === DEVELOPMENT_MODE) {
      document.title = import.meta.env.VITE_APP_TITLE;
    }
  }, []);

  const onLocaleSwitcherChange = (_name: string, value: string) => {
    if (onLocaleChange) {
      onLocaleChange(value as Locale);
    }
  };

  return (
    <div className={styles['main-title-container']}>
      <FlexContainer justifycontent="space-between" alignitems="center" gap={5} width="calc(100% - 10px)">
        <Link to="/" className={styles.link}>
          <FlexContainer justifycontent="flex-start" alignitems="center" gap={5} width="initial">
            <img width="36" height="36" src={`${STATIC_IMG_LOCATION}/mybit-money.png`} alt="mybit-money" />
            <Typography variant="h1" className={styles['header-h1']}>
              My₿iT.money (beta)
            </Typography>
          </FlexContainer>
        </Link>
        <FlexContainer gap={10} alignitems="center">
          <LocationSwitcher
            fontSize={12}
            width={50}
            onChange={onLocaleSwitcherChange}
            id="locale"
            value={locale}
            name="locale"
            labelActive="En"
            labelInactive="Ru"
          />
          <TonConnectButton className={styles['ton-connect-button']} />
          {props.isMobileResolution && (
            <IconButton onClick={props.onMainMenuVisibleChange}>
              {props.isVisibleMainMenu ? <Close /> : <MenuIcon />}
            </IconButton>
          )}
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};

export default MainHeader;
